module.exports = __webpack_public_path__ + "static/media/thumbnail.4cfaf4d1.svg";